const USER_TOKEN = 'user_token';

export const getToken = () => {
  let name = USER_TOKEN + '=';
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
};

export const setToken = (token: string) => {
  document.cookie = `${USER_TOKEN}=${token}; path=/`;
};

export const deleteToken = () => {
  document.cookie = `${USER_TOKEN}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
};
